import { io } from 'socket.io-client';
import { config } from '../config';

const socket = io(config.SOCKET_BASE_URL, {
  withCredentials: true,
  transports: ['websocket'],
});

export default socket;
